import axios from 'axios';

export const addPayment = (payment) => async (dispatch) => {
  dispatch({ type: 'ADD_PAYMENT_REQUEST' });
  try {
    await axios.post('/', payment, {
      headers: { 'Access-Control-Allow-Origin': '*' },
      withCredentials: true,
    });
    dispatch({ type: 'ADD_PAYMENT_SUCCESS' });
  } catch (error) {
    dispatch({
      type: 'ADD_PAYMENT_ERROR',
      payload: error.response.data.message,
    });
  }
};

export const allUserPayments = (userId) => async (dispatch) => {
  dispatch({ type: 'USER_PAYMENT_REQUEST' });
  try {
    const res = await axios.get(`/payment/user/${userId}`, {
      headers: { 'Access-Control-Allow-Origin': '*' },
      withCredentials: true,
    });
    dispatch({ type: 'USER_PAYMENT_SUCCESS', payload: res.data });
  } catch (error) {
    dispatch({
      type: 'USER_PAYMENT_FAILED',
      payload: error,
    });
  }
};

export const allPayment = () => async (dispatch) => {
  dispatch({ type: 'GET_ALL_PAYMENT_REQUEST' });
  try {
    const curUser = JSON.parse(localStorage.getItem('curUser'));
    const res = await axios.get(`/payment`, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${curUser?.token}`,
      },
      withCredentials: true,
    });
    dispatch({ type: 'GET_ALL_PAYMENT_SUCCESS', payload: res.data.payments });
  } catch (error) {
    dispatch({
      type: 'GET_ALL_PAYMENT_ERROR',
      payload: error,
    });
  }
};

export const updatePayment = (id, status) => async (dispatch) => {
  dispatch({ type: 'UPDATE_PAYMENT_REQUEST' });
  try {
    const res = await axios.put(
      `/payment/${id}`,
      { status },
      {
        headers: { 'Access-Control-Allow-Origin': '*' },
        withCredentials: true,
      }
    );
    console.log(res);
    dispatch({ type: 'UPDATE_PAYMENT_SUCCESS', payload: res });
  } catch (error) {
    console.log(error);
    dispatch({
      type: 'UPDATE_PAYMENT_FAILED',
      payload: error,
    });
  }
};
